import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const MuiTooltip: {
    styleOverrides: ComponentsOverrides<Theme>['MuiTooltip'];
    defaultProps?: ComponentsProps['MuiTooltip'];
    variants?: ComponentsVariants['MuiTooltip'];
} = {
    styleOverrides: {
        tooltip: ({ ownerState, theme }) => ({
            ...theme.typography.caption,
            backgroundColor: theme.palette.grey[900],
            color: theme.palette.common.white,
            padding: '7.5px 16px',

            ...(ownerState.variant === 'light' && {
                ...theme.typography.body2,
                maxWidth: 500,
                backgroundColor: theme.palette.light.main,
                color: theme.palette.grey[900],
                padding: theme.spacing(2),
                margin: 0,
                marginTop: -14,
                boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.1444), 0px 0px 9px 0px rgba(0, 0, 0, 0.2139)',
            }),
        }),
    },
    defaultProps: {
        variant: 'dark',
        placement: 'top',
    },
};

declare module '@mui/material/Tooltip' {
    interface TooltipProps {
        variant?: 'light' | 'dark';
    }
}
